<ng-container>
	<h4>Coupons</h4>
	<div class="row">
		<div class="col-md-12">

			<div class="col-2 text-left mt-3">
				<button mat-icon-button aria-label="text" color="accent" (click)="addCouponMenu()">
					<i class="material-icons">text_snippet</i>Add Coupon
				</button>
			</div>
			<div class="card">
				<div class="card-body">
					<table class="table table-sm mt-3" style="text-align: center;">
						<tr>
							<th></th>
							<th>Name</th>
							<th>Code</th>
							<th>Type</th>
							<th>Discount</th>
							<th>Threshold Total</th>
							<th>Start Date</th>
							<th>End Date</th>
							<th>Total Uses</th>
							<th>Uses Customer</th>
							<th>Shipping?</th>
							<th>Status?</th>
							<th>Is Stackable?</th>
							<th>Is Taxable?</th>
							<th>Logged?</th>
						</tr>
						<tr *ngFor="let coupon of allCoupons">
							<td>
								<button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Actions">
									<mat-icon>more_vert</mat-icon>
								</button>

								<mat-menu #menu="matMenu">
									<button mat-menu-item (click)="editCoupon(coupon)">
										<mat-icon>edit</mat-icon>
										<span>Edit Coupon</span>
									</button>
									<button mat-menu-item (click)="deleteCoupon(coupon)">
										<mat-icon>delete</mat-icon>
										<span>Delete Coupon</span>
									</button>
								</mat-menu>
							</td>
							<td>{{ coupon.name }}</td>
							<td>{{ coupon.code }}</td>
							<td>
								<div *ngIf="coupon.type == 1; else type">Percent</div>
								<ng-template #type>Amount</ng-template>
							</td>
							<td>
								<div *ngIf="coupon.type == 1; else discount">{{ coupon.discount | number : '1.2-2' }}%</div>
								<ng-template #discount>{{ coupon.discount | currency }}</ng-template>
							</td>
							<td>{{ coupon.total | currency }}</td>
							<td>{{ coupon.date_start }}</td>
							<td>{{ coupon.date_end }}</td>
							<td>{{ coupon.uses_total }}</td>
							<td *ngIf="coupon.uses_customer != '999999999'">{{ coupon.uses_customer }}</td>
							<td *ngIf="coupon.uses_customer == '999999999'">Any</td>
							<td>
								<div *ngIf="coupon.shipping == 1; else shipping">Yes</div>
								<ng-template #shipping>No</ng-template>
							</td>
							<td>
								<div *ngIf="coupon.status == 1; else status">Enabled</div>
								<ng-template #status>Disabled</ng-template>
							</td>
							<td>
								<div *ngIf="coupon.stackable == 1; else stackable">Enabled</div>
								<ng-template #stackable>Disabled</ng-template>
							</td>
							<td>
								<div *ngIf="coupon.taxable == 1; else taxable">Enabled</div>
								<ng-template #taxable>Disabled</ng-template>
							</td>
							<td>
								<div *ngIf="coupon.logged == 1; else logged">Enabled</div>
								<ng-template #logged>Disabled</ng-template>
							</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</div>
</ng-container>

<ng-template #couponModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title"><i class="fa fa-pencil"></i>{{modename}} Coupon</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>


	 <div class="modal-body text-dark"><div class="panel panel-default">
		<div class="panel-body">
			<form id="form-coupon" [formGroup]="couponForm" class="form-horizontal">
				<div class="tab-content">
					<div class="tab-pane active" id="tab-general">
					<mat-divder class="divider"></mat-divder>
					<h4>Coupon Settings</h4>


						<!--NAME, ENTRY CODE -->
						<div style="display: flex; flex-direction: row;">
							<div class="form-group required col-sm-6">
								<label class="col-sm-12 control-label" id="input-name">Coupon Name</label>
								<div class="col-sm-12">
									<input type="text" name="name" value="" placeholder="Entry Name" id="input-name" class="form-control" formControlName="name"/>
									<label class="text-danger" *ngIf="couponForm.get('name').value.length < 3">Name must be 3 characters or longer</label>
									<label class="text-danger" *ngIf="couponForm.get('name').value.length > 128">Name cannot be longer than 128 characters</label>
								</div>
							</div>
							<div class="form-group required col-sm-6">
								<label class="col-sm-12 control-label" id="input-code">Coupon Entry Code</label>
								<div class="col-sm-12">
									<input type="text" name="name" value="" placeholder="Entry Name" id="input-name" class="form-control" formControlName="code" />
									<label class="text-danger" *ngIf="couponForm.get('code').value.length < 3">Code must be 3 characters or longer</label>
									<label class="text-danger" *ngIf="couponForm.get('code').value.length > 20">Code cannot be longer than 20 characters</label>
								</div>
							</div>
						</div>
						<div style="display: flex; flex-direction: row;">
							<div class="form-group col-sm-6">
								<label class="col-sm-12 control-label" id="input-date-start">Effective Start Date</label>
								<div class="col-sm-12">
									<input type="date" name="date_start" value="" placeholder="Start Date" data-date-format="YYYY-MM-DD" id="input-date-start" class="form-control"  formControlName="date_start" />
								</div>
							</div>

							<div class="form-group col-sm-6">
								<label class="col-sm-12 control-label" id="input-date-end">Effective End Date</label>
								<div class="col-sm-12">
									<input type="date" name="date_end" value="" placeholder="End Date" data-date-format="YYYY-MM-DD" id="input-date-end" class="form-control"  formControlName="date_end"/>
								</div>
							</div>
						</div>


						<div style="display:flex; flex-direction: row;">
							<div class="form-group col-sm-4">
								<label class="col-sm-12 control-label" id="input-uses-total">
									<span data-toggle="tooltip" title="">Number of Uses</span>
								</label>
								<div class="col-sm-12">
									<label class="text-danger" *ngIf="couponForm.get('uses_total').value < 1">Total Uses must be at least 1</label>
									<input type="number" min="1" step="1" name="uses_total" value="1" placeholder="Uses Total" id="input-uses-total" class="form-control" formControlName="uses_total"/>
								</div>
							</div>

							<div class="form-group col-sm-4">
								<label class="col-sm-12 control-label" id="input-uses-total">
									<span data-toggle="tooltip" title="">Uses Customer ID</span>
								</label>
								<div class="col-sm-12">
									<input type="text" name="uses_customer_ID" value="" placeholder="Enter Customer ID" id="input-uses-total" class="form-control" formControlName="uses_customer"/>
								</div>
							</div>

							<div class="form-group col-sm-4">
								<label class="col-sm-12 control-label" id="input-uses-total">
									<span data-toggle="tooltip" title="">Status?</span>
								</label>

								<div class="col-sm-12">
									<select name="type" id="input-type" class="form-control"  formControlName="status">
										<option value="1">Enabled</option>
										<option value="0">Disabled</option>
									</select>
								</div>
							</div>
						</div>


		
						<div style="display: flex; flex-direction: row;">
							<div class="form-group col-sm-4">
								<label class="col-sm-12 control-label" id="input-type"><span data-toggle="tooltip" title=""></span>Coupon Type</label>
								<div class="col-sm-12">
									<select name="type" id="input-type" class="form-control"  formControlName="type"  >
										<option value="1" selected="selected">Percent</option>
										<option value="0">Amount</option>
									</select>
								</div>
							</div>

							<div class="form-group col-sm-4">
								<label class="col-sm-12 control-label" id="input-discount">Discount Amount</label>
								<div class="col-sm-12">
									<label class="text-danger" *ngIf="couponForm.get('discount').value < 0">Discount amount must be positive</label>
									<label class="text-danger" *ngIf="couponForm.get('discount').value > 100 && couponForm.get('type').value == 1">Discount cannot be greater than 100</label>
									<input type="number" min="0" name="name" value="" placeholder="Coupon Discount" class="form-control" formControlName="discount" />
								</div>
							</div>

							<div class="form-group col-sm-4">
								<label class="col-sm-12 control-label" id="input-total">Entry Total</label>
								<div class="col-sm-12">
									<label class="text-danger" *ngIf="couponForm.get('total').value < 0">Total must be positive</label>
									<input type="number" min="0" name="name" value="" placeholder="Entry Total" class="form-control" formControlName="total" />
								</div>
							</div>
						</div>


						<div style="display: flex; flex-direction: row; padding: 0px;" class="col-sm-12">
							<div class="form-group col-sm-4">
								<label class="col-sm-12 control-label" id="input-shipping">Free Shipping</label>
								<div class="col-sm-12">
									<select name="type" id="input-type" class="form-control"  formControlName="shipping">
										<option value="1">Yes</option>
										<option value="0">No</option>
									</select>
								</div>
							</div>

							<div class="form-group col-sm-4">
								<label class="col-sm-12 control-label" id="input-uses-total">
									<span data-toggle="tooltip" title="">Is Taxable?</span>
								</label>

								<div class="col-sm-12">
									<select name="type" id="input-type" class="form-control"  formControlName="taxable">
										<option value="1">Enabled</option>
										<option value="0">Disabled</option>
									</select>
								</div>
							</div>

							<div class="form-group col-sm-4">
								<label class="col-sm-12 control-label" id="input-uses-total">
									<span data-toggle="tooltip" title="">Is Stackable?</span>
								</label>

								<div class="col-sm-12">
									<select name="type" id="input-type" class="form-control"  formControlName="stackable">
										<option value="1">Enabled</option>
										<option value="0">Disabled</option>
									</select>
								</div>
							</div>
						</div>



						<br>
						
						<mat-divder class="divider"></mat-divder>
						<h4>Coupon Items</h4>


						
						<div style="display: flex; flex-direction: row;">
							<div class="form-group col-sm-12">
								<div style="display: flex; flex-direction: row;">
									<div class="col-sm-12">
									<app-item-picker (saveresults)="addItems($event);"></app-item-picker>										
									</div>
								</div>
								<div style="display: flex; flex-direction: row;">
									<div id="coupon-category" class="col-sm-12">
										<table class="table table-striped table-hover table-bordered">
											<thead class="thead-dark">
												<tr>
													<th scope="col">Item Number</th>
													<th scope="col">Description</th>
													<th></th>
												</tr>
											</thead>
											<tbody>
												<ng-container *ngFor="let i of couponForm.get('coupon_product').value">
												<tr>
													<td>{{ i.stockid}}</td>
													<td>{{ i.description}}</td>
													<td><button mat-icon-button (click)="deleteItem(i)" title="Delete"><mat-icon>remove</mat-icon></button></td>
												</tr>
												</ng-container>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>

	<button *ngIf="!submitting" data-toggle="tooltip" title="Save and {{modename}} Coupon" class="btn btn-primary" (click)="saveOrEditCoupon()" (keyup.enter)="$event.preventDefault(); $event.stopPropagation()" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><i class="fa fa-save"></i></button>
	<div class="text-center contents" *ngIf='submitting'>
		<svg class="spinner" width="50px" height="50px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
			<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
		</svg>
	</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>
